/* eslint-disable global-require,@typescript-eslint/no-var-requires */
import { Apps } from '@/constants/apps';
import HomescapesCover from '@/assets/images/homescapes/cover.jpeg';
import TownshipCover from '@/assets/images/township/cover.png';
import TownshipCover2x from '@/assets/images/township/cover@2x.jpeg';
import HomescapesLogo2x from '@/assets/images/homescapes/game-logo@2x.png';
import TownshipLogo2x from '@/assets/images/township/game-logo@2x.png';

const COVER: Record<string, string> = {
  homescapes: require('@/assets/images/homescapes/trailer-cover.webp'),
  township: require('@/assets/images/township/trailer-cover.webp'),
};

const TRAILERS: Record<string, Record<string, string>> = {
  homescapes: {
    ru: require('@/assets/videos/homescapes/trailer/ru.mp4'),
    en: require('@/assets/videos/homescapes/trailer/en.mp4'),
  },
  township: {
    en: require('@/assets/videos/township/trailer/en.mp4'),
  },
};

const GAME_COVERS: Record<string, string> = {
  [Apps.Homescapes]: HomescapesCover,
  [Apps.Township]: TownshipCover,
};

const GAME_COVERS_2X: Record<string, string> = {
  [Apps.Homescapes]: HomescapesCover,
  [Apps.Township]: TownshipCover2x,
};

const LOGO2X: Record<string, string> = {
  [Apps.Homescapes]: HomescapesLogo2x,
  [Apps.Township]: TownshipLogo2x,
};

export { COVER, TRAILERS, GAME_COVERS, GAME_COVERS_2X, LOGO2X };
